module.exports = __webpack_public_path__ + "static/media/Admin.2317ad13.PNG";